import React from "react";
import "./Header.css";
import imagenHeader from "./Components/ImagenHeader.png";
import Nav from "./Components/Nav";
const Header = () => {
  return (
    <div className="global-header">
      <Nav/>
      <div className="content-header">
        <div className="texto-header">
          <h6 className="title-h6">WhatsApp Pricing Calculator</h6>
          <h1 className="title-h1">
            Calcula tus costos con nuestra calculadora de precios de WhatsApp
          </h1>
          <p className="title-p">
            Haz que cada mensaje cuente pagando sólo por las conversaciones que
            tengas
          </p>
        </div>
        <div className="imagen-header">
          <img src={imagenHeader} alt="" className="ImagenHeader" />
        </div>
      </div>
    </div>
  );
};

export default Header;
